module.exports = __webpack_public_path__ + "static/ro-trainings-5-31692ba877a9ebbfea7e2471944df2d6.jpg";